// extracted by mini-css-extract-plugin
export default {"sticky":"OcJhl3dAlEp9O2yGmz4a","dateSwitcher":"xOPLyQzEfxWqe9Yw4LeO","flex":"Uw03A9A8ZImXCniVoRB1","placeHolderShimmer":"mdraAJ712iiyGKxicAyJ"};